export const BASE_CLIENT_URL = "https://platform.yedyni.org";

export const AXIOS_BASE_URL = 'https://server.yedyni.org';

// export const AXIOS_BASE_URL = 'http://localhost:3000';

export const API_PAY_ENDPOINT = 'https://www.liqpay.ua/api/3/checkout';

export const BASE_AMOUNT_SUPPORT = 40;

export const BASE_COURSE_TIME = 2419200;
